// SystemDevice Actions
import {
  GET_SYSTEM_DEVICE_LIST,
  GET_SYSTEM_DEVICE_LIST_SUCCESS,
  GET_SYSTEM_DEVICE_LIST_FAILURE,
  GET_EPOSSYSTEM_DATA,
  GET_EPOSSYSTEM_DATA_SUCCESS,
  GET_EPOSSYSTEM_DATA_FAILURE,
  CREATE_SYSTEM_DEVICE,
  CREATE_SYSTEM_DEVICE_SUCCESS,
  CREATE_SYSTEM_DEVICE_FAILURE,
  UPDATE_SYSTEM_DEVICE,
  UPDATE_SYSTEM_DEVICE_SUCCESS,
  UPDATE_SYSTEM_DEVICE_FAILURE,
  DELETE_SYSTEM_DEVICE,
  DELETE_SYSTEM_DEVICE_SUCCESS,
  DELETE_SYSTEM_DEVICE_FAILURE,
} from "./actionType";

// Get SystemDevice List
export const getSystemDeviceList = () => ({
  type: GET_SYSTEM_DEVICE_LIST,
});

export const getSystemDeviceListSuccess = (data) => ({
  type: GET_SYSTEM_DEVICE_LIST_SUCCESS,
  payload: data,
});

export const getSystemDeviceListFailure = (error) => ({
  type: GET_SYSTEM_DEVICE_LIST_FAILURE,
  payload: error,
});

// Get EPOS system data
export const getEposSystemData = (data) => ({
  type: GET_EPOSSYSTEM_DATA,
  payload: data,
});

export const getEposSystemDataSuccess = (data) => ({
  type: GET_EPOSSYSTEM_DATA_SUCCESS,
  payload: data,
});

export const getEposSystemDataFailure = (error) => ({
  type: GET_EPOSSYSTEM_DATA_FAILURE,
  payload: error,
});

// Create SystemDevice
export const createSystemDevice = (data) => ({
  type: CREATE_SYSTEM_DEVICE,
  payload: data,
});

export const createSystemDeviceSuccess = (data) => ({
  type: CREATE_SYSTEM_DEVICE_SUCCESS,
  payload: data,
});

export const createSystemDeviceFailure = (error) => ({
  type: CREATE_SYSTEM_DEVICE_FAILURE,
  payload: error,
});

// Update SystemDevice
export const updateSystemDevice = (data) => ({
  type: UPDATE_SYSTEM_DEVICE,
  payload: data,
});

export const updateSystemDeviceSuccess = (data) => ({
  type: UPDATE_SYSTEM_DEVICE_SUCCESS,
  payload: data,
});

export const updateSystemDeviceFailure = (error) => ({
  type: UPDATE_SYSTEM_DEVICE_FAILURE,
  payload: error,
});

// Delete SystemDevice
export const deleteSystemDevice = (data) => ({
  type: DELETE_SYSTEM_DEVICE,
  payload: data,
});

export const deleteSystemDeviceSuccess = (data) => ({
  type: DELETE_SYSTEM_DEVICE_SUCCESS,
  payload: data,
});

export const deleteSystemDeviceFailure = (error) => ({
  type: DELETE_SYSTEM_DEVICE_FAILURE,
  payload: error,
});


